import helloWorld from './helloWorld.example'
import '../css/style.scss'
helloWorld()

$('[data-submenu-trigger]').click(function (event) {
  event.preventDefault();
  console.log('test');
  $(this).toggleClass('active');
  $(this).parent().parent().find('.c-sub-menu').toggle('.show')
});